module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedExtraBold.b05732f.woff";